import ApiClient, { ApiCallError } from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import camelcaseKeys from 'camelcase-keys'
import { HealthLimitationSet } from '@src/data/health-limitation-set'
import { snakecaseKeys } from '@src/util/functions'
import SessionManager from '@src/lib/session_manager'

type HealthLimitationsResponse = { health_limitations_sets: HealthLimitationSet[] }
type HealthLimitationsSet = { health_limitations_set: HealthLimitationSet }

export class HealthLimitationService {

  apiClient: ApiClient = new ApiClient()

  loadLatestHealthLimitations (memberId): Promise<HealthLimitationSet> {
    const api = SessionManager.Instance.isManager() ? API.TRAINERS_API.HEALTH_LIMITATIONS_SETS : API.MEMBERS_API.HEALTH_LIMITATIONS_SETS
    return this.apiClient.get<HealthLimitationsResponse>(api.replace('{memberId}', memberId))
      .then((response) => {
        let latestSet = {}
        if (response.health_limitations_sets.length) {
          latestSet = response.health_limitations_sets.sort((a, b) => b.id - a.id)[0]
          for (let prop in latestSet) {
            if (latestSet[prop] === null) delete latestSet[prop]
          }
        }
        return Promise.resolve(new HealthLimitationSet(camelcaseKeys(latestSet)))
      })
      .catch((err: ApiCallError) => {
        console.error('Failed to retrieve health limitations, ', err)
        return Promise.reject(err)
      })
  }

  loadHealthLimitationSet (healthLimitationId: number, memberId: string): Promise<HealthLimitationSet> {
    const api = SessionManager.Instance.isManager() ? API.TRAINERS_API.HEALTH_LIMITATIONS_SETS : API.MEMBERS_API.HEALTH_LIMITATIONS_SETS
    return this.apiClient.get<HealthLimitationsSet>(`${api.replace('{memberId}', memberId)}/${healthLimitationId}`)
      .then((response) => {
        return new HealthLimitationSet(camelcaseKeys(response.health_limitations_set))
      })
      .catch((err: ApiCallError) => {
        console.error('Failed to retrieve specified health limitations, ', err)
        return Promise.reject(err)
      })
  }

  addHealthLimitationSet (healthLimitationsSet: HealthLimitationSet, memberId: string): Promise<HealthLimitationSet> {
    const data = { health_limitations_set: snakecaseKeys(healthLimitationsSet) }
    return this.apiClient.post<HealthLimitationsSet>(API.TRAINERS_API.HEALTH_LIMITATIONS_SETS.replace('{memberId}', memberId), data)
        .then((response) => {
          return response.health_limitations_set ? new HealthLimitationSet(camelcaseKeys(response.health_limitations_set)) : new HealthLimitationSet()
        })
        .catch((err: ApiCallError) => {
          console.error('Failed to update health limitations, ', err)
          return Promise.reject(err)
        })
  }
}
